import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery'
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import ManagePage from '../../views/ManagePage/';
const GLOBAL = require('../../Globals');

class EditUser extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			uname : '',
			ugender : '',
			udob : '',
			uaddress : '',
			country : '',
			region : '',
			uemail : '',
			username : '',
			upass : '',
			ucity : '',
			umobile : '',
			urole : '',
			ustatus : '',
			_message : '',
			value : '',
			alertClass :'',
			_redirect : '',
			posts : [],
			employees : [],
			small: false,
			npass : '',
			cpass : '',
		}
		/** bind function **/
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onReset = this.onReset.bind(this);
		this.toggleSmall = this.toggleSmall.bind(this);
		this.onUpdatePass = this.onUpdatePass.bind(this);
	}
	
	onUpdatePass(){
		
		var newpass = $("#npass").val();
		var conpass = $("#cpass").val();
		
		if(newpass === conpass){
			
			PostData('user/updatepass',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					alert('Password Updated Successfully');
					this.toggleSmall();
				}
			});
		}
		else{
			
			alert('Does Not Match');
		}
	}
	
	toggleSmall(){
		this.setState({
		  small: !this.state.small
		});
	}
	
	onReset(){
		this.setState({
		  small: !this.state.small
		});
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	/** submit form **/
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		PostData('user/edit',this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.setState({
					_message:'User Updated Successfully!..',
					alertClass:'alert alert-success',
				});
				document.getElementById("userform").reset();
			}
			else{
		
				this.setState({
					_message:'Already Added',
					alertClass:'alert alert-danger'
				});
			}
		});
	}
	
	selectCountry (val) {
		this.setState({ country: val });
	}
 
	selectRegion (val) {
		this.setState({ region: val });
	}
	
	componentDidMount(){
		this.getdata();
	}

	getdata() {
		$("#showLoader").show();
		GetData('employee/getemployee').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					employees: responseJson
				});
			}
		});
	}

	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getdetails();
	}
	
	/** get Academic Details **/
	getdetails(){
	  $("#showLoader").show();
		GetData('user/getuserbyid/'+this.props.match.params.id).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
				uname : res[0]['name'],
				uemail : res[0]['email'],
				ugender : res[0]['gender'],
				udob : res[0]['dob'],
				ucity: res[0]['city'],
				umobile: res[0]['mobile'],
				uaddress: res[0]['address'],
				country: res[0]['country'],
				region: res[0]['state'],
				ustatus: res[0]['userstatus'],
				urole: res[0]['role'],
				staffid: res[0]['staffid'],
				});
				
			}
			
		});
		
	}
	
  render() {
	
	/** match id to update **/
	this.state.id = this.props.match.params.id;
	
	this.gen = [
		{value : '', name : 'Select Gender'},
		{value : 'male', name : 'Male'},
		{value : 'female', name : 'Female'}
	];
	
	/** set status select box **/
	this.userstatus = [
		{value : '', name : 'Select'},
		{value : 'active', name : 'Active'},
		{value : 'block', name : 'Block'}
	];
	
	/** set userrole select box **/
	this.userrole = [
		{value : '', name : 'Select'},
		{value : 'admin', name : 'Admin'},
		{value : 'staff', name : 'Staff'},
		{value : 'markentry', name : 'Mark Entry'},
		{value : 'classteacher', name : 'Class Teacher'},
		{value : 'questionbank', name : 'Question Bank'},
		{value : 'library', name : 'Library'},
		{value : 'smsapp', name : 'Sms App'},
		{value : 'accountant', name : 'Accountant'}
	];
	
	/** Redirect to update page **/
	if(this.state._redirect){
		  
		return (<Redirect to={'/settings/academicupdate/'+this.state.idd} />);

	}
	
    return (
		<div>
		  <ManagePage />
			<div className="animated fadeIn">
			  <form action="" method="post" role="form" id="userform" encType="multipart/form-data" onSubmit={this.onSubmit}>
				<Row>
				  <Col md="12">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Card>
						<CardHeader>
							<strong>Edit User</strong>
							<Button outline color="primary" className="btn-right" onClick={this.onReset}>Reset Password</Button>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Name <span className="text-danger">*</span></Label>
								  <input type="text" name="uname" className="form-control" onChange={this.onChange} required value={this.state.uname} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Email</Label>
								  <input type="email" name="uemail" className="form-control" onChange={this.onChange} value={this.state.uemail} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Gender <span className="text-danger">*</span></Label>
								  <select name="ugender" className="form-control" onChange={this.onChange} required value={this.state.ugender}>
									{this.gen.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}		
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Dob</Label>
								  <input type="date" name="udob" className="form-control" onChange={this.onChange} value={this.state.udob} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Address</Label>
								  <input type="text" name="uaddress" className="form-control" onChange={this.onChange} value={this.state.uaddress} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">City</Label>
								  <input type="text" name="ucity" className="form-control" onChange={this.onChange} value={this.state.ucity} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Mobile</Label>
								  <input type="number" name="umobile" className="form-control" onChange={this.onChange} value={this.state.umobile} />
								</FormGroup>
							  </Col>
							   <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Country</Label>
								  <CountryDropdown value={this.state.country} onChange={(val) => this.selectCountry(val)} id="con" />
								</FormGroup>
							  </Col>
							   <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">State</Label>
								 <RegionDropdown country={this.state.country} value={this.state.region} onChange={(val) => this.selectRegion(val)} id="con" />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Role <span className="text-danger">*</span></Label>
								  <select name="urole" className="form-control" onChange={this.onChange} required value={this.state.urole} >
									{this.userrole.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}		
								  </select>
								</FormGroup>
							  </Col>
							  {(this.state.urole == 'questionbank' || this.state.urole == 'markentry' || this.state.urole == 'classteacher') ?
							  <Col md="3">
								  <FormGroup>
									  <Label>Staff <span className="text-danger">*</span></Label>
									  <select name="staffid" className="form-control" onChange={this.onChange} required value={this.state.staffid} required>
										  <option value="">Select Staff</option>
										{this.state.employees.map((e, key) => {
											return <option key={key} value={e.id}>{e.empcode} - {e.empname}</option>;
										})}		
									  </select>
								  </FormGroup>
							  </Col> : ''}
							   <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Status <span className="text-danger">*</span></Label>
								  <select name="ustatus" className="form-control" onChange={this.onChange} required value={this.state.ustatus}>
									{this.userstatus.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}		
								  </select>
								</FormGroup>
							  </Col>
							  <Modal isOpen={this.state.small} toggle={this.toggleSmall} className={'modal-sm ' + this.props.className}>
							  <ModalHeader toggle={this.toggleSmall}>Reset Password</ModalHeader>
							  <ModalBody>
								<Row>
								  <Col md="12">
								   <FormGroup>
									<Label htmlFor="name">New Password <span className="text-danger">*</span></Label>
									<input type="password" name="npass" id="npass" onChange={this.onChange} className="form-control" />
								   </FormGroup>
								  </Col>
								  <Col md="12">
								   <FormGroup>
									<Label htmlFor="name">Confirm Password <span className="text-danger">*</span></Label>
									<input type="password" name="cpass" data-match="#nPass" id="cpass" onChange={this.onChange} className="form-control" />
								   </FormGroup>
								  </Col>
								</Row>
							  </ModalBody>
							  <ModalFooter>
								<Button color="secondary" onClick={this.toggleSmall}>Cancel</Button>{' '}
								<Button color="primary" onClick={this.onUpdatePass}>Update</Button>
							  </ModalFooter>
							</Modal>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary" className="btn-right"><i className="fa fa-dot-circle-o"></i> Update User</Button>
						</CardFooter>
					</Card>
				  </Col>
				</Row>
			  </form>
			</div>
		</div>
	)
  }
}

export default EditUser;


// WEBPACK FOOTER //
// ./src/users/AllUser/EditUser.js